export const PARENT_PROFILE_ACTION = 'PARENT_PROFILE_ACTION';
export const PARENT_PROFILE_SUCCESS_ACTION = 'PARENT_PROFILE_SUCCESS_ACTION';
export const PARENT_PROFILE_FAILURE_ACTION = 'PARENT_PROFILE_FAILURE_ACTION';
